
import ReviewsViewLazyImage from '../LazyImage.vue';

export default {
  name: 'ReviewsViewMapSectionGoogleMap',
  components: {
    ReviewsViewLazyImage,
  },
  props: {
    link: {
      type: String,
      reqquired: true,
    },
  },
  data() {
    return {
      isImgLoaded: new Array(1).fill(false),
      imageUrl: '/skin/frontend/onestopbedrooms/default/images/review',
    };
  },
  computed: {
    googleMap() {
      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/map_img_v1.png`,
        alt: 'Google Map Image',
        sources: [
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/map_img_mob_v1.png`,
            media: '(max-width: 767px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/map_img_tablet_v1.png`,
            media: '(min-width: 768px) and (max-width: 1199px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/map_img_v1.png`,
            media: '(min-width: 1200px)',
          },
        ],
      };
    },
  },
  methods: {
    load(index) {
      this.$set(this.isImgLoaded, index, true);
    },
  },
};
